import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  mergeRow,
  safeText,
  setCell,
} from "./principle6SheetHelpers";
import { filterPopulatedRows, setStandardDetailWidths } from "./principle8SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Action to mitigate negative SIA";

const SHEET_TITLE =
  "Provide details of actions taken to mitigate any negative social impacts identified in the Social Impact Assessments";

export function buildActionToMitigateNegativeSIASheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setStandardDetailWidths(ws, { D: 8, E: 32, F: 32 });

  const rows = filterPopulatedRows(
    sectionC?.principle8?.leadershipIndicator?.socialImpactAssessments,
    ["details", "correctiveActionTaken"]
  );

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_8, { mergeEnd: COL_F });

  mergeRow(ws, TITLE_ROW, COL_D, COL_F, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Details of negative social impact identified", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_F, "Corrective action taken", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.details), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.correctiveActionTaken), { align: "left" });
  });

  return ws;
}
